export const getSuperAdminDashboardEndpoint = () => `/api/super-admin-dashboard`;
export const getSuperAdminDashboardChartEndpoint = (type: string) => `/api/super-admin-dashboard/line-graph?type=${type}`;